module.exports = __webpack_public_path__ + "img/burger-icon-v2.250c883d.svg";